import { QuoteProductID } from "./QuoteProductID";

export const GetHandoffPath = (id) => {
  switch (id) {
    case  QuoteProductID.LGA_PRODUCT_ID:
      return "/handoff-lga";
    case QuoteProductID.PRUDENTIAL_SIMPLY_TERM_PRODUCT_ID:
      return "/handoff-prudential";
    default:
      return "";
  }
}